module.exports = __webpack_public_path__ + "img/translate5.2d81a139.jpg";